/**
 * Tagged template and callable helper to normalise links.
 *
 * Usage:
 * - linky`path` → "/path"
 * - linky`/path` → "/path"
 * - linky`https://example.com` → "https://example.com"
 * - linky("path") → "/path"
 */

export function linky(strings: TemplateStringsArray, ...expressions: unknown[]): string | undefined
export function linky(href?: string | null): string | undefined
export function linky(first?: TemplateStringsArray | string | null, ...rest: unknown[]): string | undefined {
	// eslint-disable-next-line no-useless-assignment
	let source_string = ''

	if (Array.isArray(first) && 'raw' in first) {
		const strings = first as TemplateStringsArray
		const expressions = rest

		let built = ''
		for (let i = 0; i < strings.length; i += 1) {
			built += strings[i] ?? ''
			if (i < expressions.length) {
				const expr = expressions[i]
				built += expr == null ? '' : String(expr)
			}
		}
		source_string = built
	} else {
		source_string = String(first ?? '')
	}

	const trimmed = source_string.trim()

	if (trimmed === '') return undefined

	// leave absolute http(s) links untouched
	if (/^https?:\/\//i.test(trimmed)) return trimmed

	if (trimmed.startsWith('/')) return trimmed

	return `/${trimmed}`
}
